import { render, staticRenderFns } from "./stdIntroduce.vue?vue&type=template&id=58648516"
import script from "./stdIntroduce.vue?vue&type=script&lang=js"
export * from "./stdIntroduce.vue?vue&type=script&lang=js"
import style0 from "./stdIntroduce.vue?vue&type=style&index=0&id=58648516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports